import { Text } from '@chakra-ui/layout';
import { Button, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import { FC } from 'react';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

interface IWhyReasons {
  title: string;
  buttonText: string;
  description: string;
  buttonLink: string;
}

export const EventType: FC<IWhyReasons> = ({ buttonText, title, description, buttonLink }) => {
  return (
    <Flex w="full" alignItems="center" flexDirection="column">
      <Text mt={4} mb={2} fontWeight="bold" fontFamily="heading" fontSize="3xl" color="violet.500">
        {title}
      </Text>
      <Text textAlign="center">{description}</Text>
      <Button as={Link} href={buttonLink} variant="solid" mt={4} rightIcon={<ArrowIcon />}>
        {buttonText}
      </Button>
    </Flex>
  );
};
